import { render, staticRenderFns } from "./VATPeriods.yaml?vue&type=template&id=0ce0ab57&component"
import script from "./VATPeriods.yaml?vue&type=script&lang=ts&component"
export * from "./VATPeriods.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports